// ─────────────────────────────────────────────
//  pwaUpdate.js — Registro y actualización del Service Worker
// ─────────────────────────────────────────────

const listeners = new Set();
let registration = null;
let reloading = false;

const state = {
	supported: 'serviceWorker' in navigator,
	updateAvailable: false,
	checking: false,
	applying: false,
	error: null,
};

function notify() {
	listeners.forEach((fn) => fn({ ...state }));
}

function markUpdateAvailable() {
	if (!state.updateAvailable) {
		state.updateAvailable = true;
		notify();
	}
}

function trackWorker(worker) {
	if (!worker) return;

	worker.addEventListener('statechange', () => {
		if (worker.state === 'installed' && navigator.serviceWorker.controller) {
			markUpdateAvailable();
		}
	});
}

export function subscribePwaUpdate(listener) {
	listeners.add(listener);
	listener({ ...state });
	return () => listeners.delete(listener);
}

export function getPwaUpdateState() {
	return { ...state };
}

export async function registerServiceWorker() {
	if (!state.supported) return null;

	try {
		registration = await navigator.serviceWorker.register('/sw.js');

		if (registration.waiting) {
			markUpdateAvailable();
		}

		registration.addEventListener('updatefound', () => {
			trackWorker(registration.installing);
		});

		navigator.serviceWorker.addEventListener('controllerchange', () => {
			if (reloading) return;
			reloading = true;
			window.location.reload();
		});

		notify();
		return registration;
	} catch (error) {
		state.error = error.message;
		notify();
		return null;
	}
}

export async function checkForUpdates() {
	if (!registration) return;

	state.checking = true;
	state.error = null;
	notify();

	try {
		await registration.update();
		if (registration.waiting) {
			markUpdateAvailable();
		}
	} catch (error) {
		state.error = error.message;
	} finally {
		state.checking = false;
		notify();
	}
}

export function applyUpdate() {
	if (!registration?.waiting) return false;

	state.applying = true;
	notify();

	registration.waiting.postMessage({ type: 'SKIP_WAITING' });
	return true;
}
